import Pages from "layouts/Pages.jsx";
//import RTL from "layouts/RTL.jsx";
import Dashboard from "layouts/Dashboard.jsx";

var indexRoutes = [
  { path: "/user", name: "User", component: Dashboard, isLoggedIn:true },
  { path: "/admin", name: "Admin", component: Dashboard, isLoggedIn:true },
  { path: "/dev", name: "Dev", component: Dashboard, isLoggedIn:true },
  { path: "/customer", name: "Customer", component: Dashboard, isLoggedIn:true },
  { path: "/receiver", name: "Receiver", component: Dashboard, isLoggedIn:true },
  { path: "/dashboard", name: "Receiver", component: Dashboard, isLoggedIn:true },
  { path: "/", name: "Pages", component: Pages, isLoggedIn:false },
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx